module.exports = __webpack_public_path__ + "img/signFile.8828f694.svg";